import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';
import { forwardRef } from 'react';

export const UniversalIcon = forwardRef<SVGSVGElement, SvgWrapperProps>(
  (props, ref) => (
    <SvgWrapper fill='none' ref={ref} viewBox='0 0 16 16' {...props}>
      <circle cx='1.5' cy='7.5' r='1.5' fill='currentColor' />
      <path d='M1.5 7.5L8.5 13.5L14.5 14.5V7.5' stroke='currentColor' />
      <path d='M1.5 7.5H8.5H14.5' stroke='currentColor' />
      <path d='M14.5 7.5L8.5 13.5V8.5' stroke='currentColor' />
      <path d='M1.5 7.5L8.5 2.5L14.5 1.5' stroke='currentColor' />
      <circle cx='8.5' cy='2.5' r='1.5' fill='currentColor' />
      <circle cx='14.5' cy='1.5' r='1.5' fill='currentColor' />
      <circle cx='8.5' cy='7.5' r='1.5' fill='currentColor' />
      <circle cx='14.5' cy='7.5' r='1.5' fill='currentColor' />
      <circle cx='8.5' cy='13.5' r='1.5' fill='currentColor' />
      <circle cx='14.5' cy='14.5' r='1.5' fill='currentColor' />
    </SvgWrapper>
  ),
);

UniversalIcon.displayName = 'UniversalIcon';
